import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { NextPageService } from "@cvx/nextpage";
import { NextPageRoute } from "@cvx/nextpage/public_api";
import { HomeComponent } from "./home/home.component";
import { AdministrationComponent } from "./administration/administration.component";
import { EnterRequestComponent } from "./enter-request/enter-request.component";
import { ManageRequestComponent } from "./manage-request/manage-request.component";
import { ReportComponent } from "./reports/report.component";
import { SearchRequestComponent } from "./manage-request/search-request/search-request.component";
import { DetailedReportComponent } from "./reports/detailed-report/detailed-report.component";
import { RequestsPendingMyActionComponent } from "./manage-request/requests-pending-my-action/requests-pending-my-action.component";
import { EmployeeBankAccountComponent } from "./administration/employee-bank-account/employee-bank-account.component";
import { ImprestVendorsComponent } from "./administration/imprest-vendors/imprest-vendors.component";
import { PayGradeBenefitsComponent } from "./administration/pay-grade-benefits/pay-grade-benefits.component";
import { MyOpenRequestsComponent } from "./manage-request/my-open-requests/my-open-requests.component";
import { TreasuryRateComponent } from "./administration/treasury-rate/treasury-rate.component";
import { DistanceBetweenLocationsComponent } from "./administration/distance-between-locations/distance-between-locations.component";
import { EmployeeCategoriesComponent } from "./administration/employee-categories/employee-categories.component";
import { RequestLineTypesComponent } from "./administration/request-line-types/request-line-types.component";
import { DistanceBetweenLocationsChangesComponent } from "./administration/distance-between-locations-changes/distance-between-locations-changes.component";
import { EmployeeBankAccountChangesComponent } from "./administration/employee-bank-account-changes/employee-bank-account-changes.component";
import { ImprestVendorsChangesComponent } from "./administration/imprest-vendors-changes/imprest-vendors-changes.component";
import { RequestTypeChangesComponent } from "./administration/request-type-changes/request-type-changes.component";
import { RecurringBenefitsHistoryComponent } from "./reports/recurring-benefits-history/recurring-benefits-history.component";
import { LineTypeChangesComponent } from "./administration/line-type-changes/line-type-changes.component";
import { EmployeeCategoriesChangesComponent } from "./administration/employee-categories-changes/employee-categories-changes.component";
import { SummaryReportComponent } from "./reports/summary-report/summary-report.component";
import { SalaryAccountPaymentComponent } from "./reports/salary-account-payment/salary-account-payment.component";
import { UnauthorizedComponent } from "./shared/unauthorized/unauthorized/unauthorized.component";
import { CalGuardService, RoleGuardService } from "@cvx/cal-angular";
import { SearchRequestGridComponent } from "./manage-request/search-request-grid/search-request-grid.component";

const routesWithParams: Routes = [
  {
    path: "enter-request/:id",
    title: "enter request",
    component: EnterRequestComponent,
    canActivate: [CalGuardService]
  },
  {
    path: "request-details/:id",
    title: "request details",
    component: SearchRequestGridComponent,
    canActivate: [CalGuardService]
  },
  {
    path: "unauthorized",
    title: "unauthorized",
    component: UnauthorizedComponent,
    }  
];


export const routes: NextPageRoute[] = [
  {
    path: "home",
    title: "home",
    redirectTo: "/",
    pathMatch: "full",
  },
    {
      path: "enter-request",
      title: "enter request",
      component: EnterRequestComponent,
      canActivate: [CalGuardService]
    },
    {
    path: "manage-request",
    title: "manage request",
    children: [
      {
        path: "",
        title: "manage request",
        component: ManageRequestComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "search-request",
        title: "search for requests",
        component: SearchRequestComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "app-my-open-requests",
        title: "my open requests",
        component: MyOpenRequestsComponent,
        canActivate: [CalGuardService]
      },    
      
      {
        path: "requests-pending-my-action",
        title: "requests pending my action",
        component: RequestsPendingMyActionComponent,
        canActivate: [CalGuardService]
      },      
    ]
  },
  {
    path: "reports",
    title: "reports",
    children: [
      {
        path: "",
        title: "reports",
        component: ReportComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "detailed-report",
        title: "detailed report",
        component: DetailedReportComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "summary-report",
        title: "summary report",
        component: SummaryReportComponent,
        canActivate: [CalGuardService]
      },      
      {
        path: "recurring-benefits-history",
        title: "recurring benefits history",
        component: RecurringBenefitsHistoryComponent,
        canActivate: [CalGuardService]
      },      
      {
        path: "salary-account-payments",
        title: "salary account payments",
        component: SalaryAccountPaymentComponent,
        canActivate: [CalGuardService]
      },
    ]
  },
  {
    path: "administration",
    title: "admin",
    children: [
      {
        path: "",
        title: "administration",
        component: AdministrationComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "employee-bank-account",
        title: "employee bank accounts",
        component: EmployeeBankAccountComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "pay-grade-benefits",
        title: "pay grade benefits",
        component: PayGradeBenefitsComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "request-line-types",
        title: "request and line types",
        component: RequestLineTypesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "treasury-rate",
        title: "treasury dollar to naira rate",
        component: TreasuryRateComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "employee-categories",
        title: "employee categories",
        component: EmployeeCategoriesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "distance-between-locations",
        title: "distance between locations",
        component: DistanceBetweenLocationsComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "imprest-vendors",
        title: "imprest vendors",
        component: ImprestVendorsComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "bank-account-changes",
        title: "bank account changes",
        component: EmployeeBankAccountChangesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "employee-categories-changes",
        title: "employee categories changes",
        component: EmployeeCategoriesChangesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "request-type-changes",
        title: "request type changes",
        component: RequestTypeChangesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "line-type-changes",
        title: "line type changes",
        component: LineTypeChangesComponent,
        canActivate: [CalGuardService]
      },      
      {
        path: "distance-between-locations-changes",
        title: "distance between locations changes",
        component: DistanceBetweenLocationsChangesComponent,
        canActivate: [CalGuardService]
      },
      {
        path: "imprest-vendors-changes",
        title: "imprest vendors changes",
        component: ImprestVendorsChangesComponent,
        canActivate: [CalGuardService]
      },
    ],
  },  
  {
    path: "user-guide",
    title: "user guide",
    component: HomeComponent,
    canActivate: [CalGuardService]
  },
  {
    path: "detailed-report",
    component: DetailedReportComponent,
    canActivate: [CalGuardService]
  },
  {
    path: "",
    title: "home",
    children: [
      {
        path: "",
        component: HomeComponent,
        canActivate: [CalGuardService]
      },
    ],
  },
];

const allRoutes: Routes = [...routes, ...routesWithParams];

@NgModule({
  imports: [RouterModule.forRoot(allRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(private NP: NextPageService) {
    this.NP.options.navigationRoutes = routes;
  }
}
